<div class="product-sync-page">
  <h1>Product Sync</h1>
  <p class="muted">
    Every vendor sync in one place. Click a vendor to open its sync buttons — syncing or
    cancelling here is the same as on the vendor's own Product Sync tab, and progress
    shows in both.
  </p>

  @if (loading()) {
    <p class="muted">Loading…</p>
  }
  @if (error()) {
    <p class="error">{{ error() }}</p>
  }

  @if (vendors().length) {
    <div class="filters">
      <mat-form-field appearance="outline" class="search">
        <mat-label>Search vendors</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          [value]="query()"
          (input)="query.set($any($event.target).value)"
          placeholder="Vendor or source name"
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Market</mat-label>
        <mat-select [value]="market()" (selectionChange)="market.set($event.value)">
          <mat-option value="">All markets</mat-option>
          @for (m of marketOptions(); track m) {
            <mat-option [value]="m">{{ m }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Channel</mat-label>
        <mat-select [value]="channel()" (selectionChange)="channel.set($event.value)">
          <mat-option value="">All channels</mat-option>
          <mat-option value="page-map">Website</mat-option>
          <mat-option value="telegram">Telegram</mat-option>
        </mat-select>
      </mat-form-field>
      <span class="muted count">{{ shown().length }} of {{ vendors().length }} vendors</span>
    </div>
    @if (!shown().length) {
      <p class="muted">
        No vendor matches.
        <button type="button" class="link-button" (click)="clearFilters()">Clear filters</button>
      </p>
    }
  }

  <mat-accordion multi class="vendor-accordion">
    @for (v of shown(); track v.key) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ v.vendorName }}
            <!-- Which markets this vendor lists into, readable without opening the section. -->
            @for (market of v.markets; track market) {
              <span
                class="market-chip"
                [matTooltip]="'Products are listed in the ' + market + ' market'"
                >{{ market }}</span
              >
            }
          </mat-panel-title>
          <mat-panel-description>
            <span class="vendor-summary">
              <span
                matTooltip="{{ v.inStock }} of {{ v.totalProducts }} in stock"
              >{{ v.totalProducts }} product{{ v.totalProducts === 1 ? '' : 's' }}</span>
              <span
                class="muted"
                matTooltip="Oldest last-updated among this vendor's sync collections"
              >
                {{ v.lastUpdated ? ('Updated ' + (v.lastUpdated | date: 'medium')) : 'Never synced' }}
              </span>
              @if (v.activeLock) {
                <span class="sync-status">
                  <mat-icon inline class="spin">sync</mat-icon>
                  {{ v.activeLock.done }}/{{ v.activeLock.total }}
                  @if (v.activeLock.currentTitle) {
                    <span class="muted">— {{ v.activeLock.currentTitle }}</span>
                  }
                  @if (v.activeLock.cancelRequested) {
                    <span class="muted">(cancelling…)</span>
                  }
                </span>
              } @else if (v.kind === 'telegram') {
                {{ v.sourceName }}
              } @else {
                {{ v.buttons }} sync button{{ v.buttons === 1 ? '' : 's' }}
              }
            </span>
            <a
              class="vendor-link"
              [routerLink]="['/vendor_input', v.vendorId]"
              (click)="stopToggle($event)"
            >
              Open vendor <mat-icon inline>open_in_new</mat-icon>
            </a>
          </mat-panel-description>
        </mat-expansion-panel-header>

        @if (v.activeLock) {
          <mat-progress-bar
            class="vendor-progress"
            [mode]="v.activeLock.total ? 'determinate' : 'indeterminate'"
            [value]="progress(v)"
          ></mat-progress-bar>
        }

        <ng-template matExpansionPanelContent>
          @if (v.kind === 'telegram') {
            <fh-telegram-ingest-panel [vendorId]="'' + v.vendorId"></fh-telegram-ingest-panel>
          } @else {
            <fh-vendor-product-sync [vendorId]="'' + v.vendorId"></fh-vendor-product-sync>
          }
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>

  @if (!loading() && !error() && !vendors().length) {
    <p class="muted">No vendor syncs are set up in this database.</p>
  }
</div>
